<prizm-icons-full [name]="prizmInputIconButton" [size]="size"></prizm-icons-full>
